

export default function Loading() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="300" height="300"
			viewBox="0 0 1920 1080" style={{enableBackground:"new 0 0 1920 1080", margin:"0 auto"}}>
				<g> 
				
					<path className="st0" fill="#FF6600" 
					d="M996,552.4L984,591h40c0,0,39-66,46-138l14-97c0,0-128-87-295-87c0,0-168-3-299,100c0,0,153-65,297-60
						c0,0,146,2,251,69l-15,95C1023,473,1005,549.8,996,552.4z"/>
					<path className="st1" fill="#002345" 
					d="M597,417h-52c0,0-40-7-48,32l-39,181c0,0,65,92,98,118s138,87.8,138,87.8S831,783,888,733c0,0,75-50,117-113
						c0,0-128,134-305,166c0,0-121-47.69-194-159.84L540,477c0,0-1-26,29-27l22,1L597,417z"/>
						<animateTransform attributeName="transform"
                          attributeType="XML"
                          type="scale"
                          values="1;1.2;1"
                          dur="1s"
                          repeatCount="indefinite"/>
				</g>
		</svg>
    )
}
